import React, { useState } from 'react';
import './Internet.css';

const Internet = () => {
  const [activeTab, setActiveTab] = useState('p2p');

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const coverageAreas = [
    'تهران (مناطق ۱ تا ۲۰)', 'تهران (مناطق ۲۱ تا ۴۰)', 'تهران (مناطق ۴۱ تا ۶۰)',
    'تهران (مناطق ۶۱ تا ۸۰)', 'تهران (مناطق ۸۱ تا ۱۰۰)', 'تهران (مناطق ۱۰۱ تا ۱۲۰)',
    'تهران (مناطق ۱۲۱ تا ۱۴۰)', 'تهران (مناطق ۱۴۱ تا ۱۶۰)', 'تهران (مناطق ۱۶۱ تا ۱۸۰)',
    'تهران (مناطق ۱۸۱ تا ۲۰۰)', 'تهران (مناطق ۲۰۱ تا ۲۲۰)', 'تهران (مناطق ۲۲۱ تا ۲۴۰)',
    'تهران (مناطق ۲۴۱ تا ۲۶۰)', 'تهران (مناطق ۲۶۱ تا ۲۸۰)', 'تهران (مناطق ۲۸۱ تا ۳۰۰)',
    'تهران (مناطق ۳۰۱ تا ۳۲۰)', 'تهران (مناطق ۳۲۱ تا ۳۴۰)', 'تهران (مناطق ۳۴۱ تا ۳۶۰)',
    'تهران (مناطق ۳۶۱ تا ۳۸۰)', 'تهران (مناطق ۳۸۱ تا ۴۰۰)',
  ];

  const cities = [
    'تهران', 'اصفهان', 'شیراز', 'تبریز', 'مشهد', 'اهواز',
    'کرج', 'قشم', 'کیش', 'گرگان', 'رشت', 'کرمانشاه',
    'یزد', 'زنجان', 'ارومیه', 'بندرعباس', 'کرمان', 'همدان',
    'اراک', 'قزوین', 'سنندج', 'بوشهر', 'خرم‌آباد', 'ساری',
    'بجنورد', 'ایلام', 'شهرکرد', 'بیرجند', 'سمنان', 'زاهدان',
  ];

  const features = [
    {
      icon: '🚀',
      title: 'سرعت بالا و پایدار',
      desc: 'اینترنت با پهنای باند اختصاصی و تأخیر کم برای تجربه‌ای بی‌نظیر در کسب‌وکارها و سازمان‌ها',
    },
    {
      icon: '📡',
      title: 'پوشش گسترده در کل کشور',
      desc: 'دسترسی به اینترنت پرسرعت در تمام نقاط ایران با فناوری پیشرفته TD-LTE و P2P',
    },
    {
      icon: '⚡',
      title: 'تکنولوژی هوشمند TD-LTE',
      desc: 'اتصال هوشمند با کیفیت بالا و مصرف بهینه انرژی با انتخاب خودکار بهترین باند',
    },
    {
      icon: '🛡️',
      title: 'امنیت و پایداری',
      desc: 'ارتباط امن و پایدار با پشتیبانی ۲۴ ساعته و پاسخگویی سریع تیم حرفه‌ای',
    },
  ];

  const faqs = [
    {
      q: 'اینترنت TD-LTE چیست و چه مزایایی دارد؟',
      a: 'TD-LTE یک فناوری اینترنت بی‌سیم نسل چهارم است که با استفاده از آنتن‌های پیشرفته، اینترنت پرسرعت را بدون نیاز به کابل‌کشی به کاربران ارائه می‌دهد. مزایای آن شامل نصب آسان، پوشش گسترده، سرعت بالا و هزینه مناسب است.',
    },
    {
      q: 'اینترنت P2P چه تفاوتی با اینترنت معمولی دارد؟',
      a: 'اینترنت P2P (نقطه‌به‌نقطه) یک اتصال اختصاصی و مستقیم بین دو نقطه است که پهنای باند کاملاً اختصاصی و بدون اشتراک با دیگران را فراهم می‌کند. این نوع اینترنت برای سازمان‌ها و کسب‌وکارهایی که به پایداری و سرعت بالا نیاز دارند، ایده‌آل است.',
    },
    {
      q: 'مناطق تحت پوشش اینترنت افراسل کجاها هستند؟',
      a: 'اینترنت TD-LTE افراسل در بیش از ۳۰ شهر بزرگ ایران از جمله تهران، اصفهان، شیراز، تبریز، مشهد و اهواز در دسترس است. همچنین اینترنت P2P در تمام مناطق ۴۰۰ گانه تهران با کیفیت تضمینی ارائه می‌شود.',
    },
    {
      q: 'چگونه می‌توانم اینترنت افراسل را سفارش دهم؟',
      a: 'برای سفارش اینترنت افراسل، می‌توانید از طریق فرم تماس با ما درخواست خود را ثبت کنید. تیم فروش ما در اسرع وقت با شما تماس گرفته و مراحل نصب و راه‌اندازی را انجام می‌دهند.',
    },
    {
      q: 'آیا اینترنت افراسل برای کسب‌وکارها مناسب است؟',
      a: 'بله، اینترنت افراسل با ارائه پهنای باند اختصاصی، آپتایم ۹۹.۹٪ و پشتیبانی ۲۴/۷، گزینه‌ای عالی برای کسب‌وکارها، فروشگاه‌های آنلاین، شرکت‌های خدمات‌دهنده و سازمان‌ها است.',
    },
    {
      q: 'هزینه نصب اینترنت افراسل چقدر است؟',
      a: 'هزینه نصب اینترنت افراسل بسته به نوع سرویس و منطقه جغرافیایی متفاوت است. برای اطلاع دقیق از هزینه‌ها، لطفاً با تیم فروش ما تماس بگیرید تا مشاوره دقیق دریافت کنید.',
    },
  ];

  const benefits = [
    {
      title: 'مناسب برای کسب‌وکارها',
      desc: 'اینترنت پرسرعت و پایدار برای فروشگاه‌های آنلاین، شرکت‌های خدمات‌دهنده و سازمان‌ها با پهنای باند اختصاصی',
    },
    {
      title: 'مناسب برای خانه و خانواده',
      desc: 'اینترنت با کیفیت بالا برای استفاده خانگی، تماشای فیلم، بازی آنلاین و کارهای روزمره با سرعت مناسب',
    },
    {
      title: 'مناسب برای شرکت‌ها و سازمان‌ها',
      desc: 'اینترنت اختصاصی با پهنای باند بالا، IP ثابت و پشتیبانی ۲۴ ساعته برای شرکت‌های بزرگ و سازمان‌ها',
    },
    {
      title: 'مناسب برای مراکز آموزشی',
      desc: 'اینترنت پرسرعت برای دانشگاه‌ها، مدارس و مراکز آموزشی با امکان اتصال همزمان تعداد زیادی کاربر',
    },
  ];

  return (
    <>
      {/* SEO Header */}
      <div className="seo-header">
        <h1>اینترنت پرسرعت افراسل — پوشش گسترده در سراسر ایران</h1>
        <p>ارائه‌دهنده اینترنت TD-LTE و P2P با پهنای باند اختصاصی، آپتایم ۹۹.۹٪ و پشتیبانی ۲۴ ساعته در تهران و سراسر ایران</p>
      </div>

      {/* Hero Section */}
      <section className="internet-hero">
        <div className="internet-hero-bg"></div>
        <div className="internet-hero-particles">
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span>
        </div>
        <div className="wrap">
          <div className="internet-hero-content">
            <div className="coming-soon-badge">
              <span className="pulse-dot"></span>
              به‌زودی در سراسر ایران
            </div>
            <h2 className="internet-hero-title">
              اینترنت <em>پرسرعت</em> افراسل
            </h2>
            <p className="internet-hero-desc">
              با تکنولوژی پیشرفته TD-LTE و P2P، اینترنت پرسرعت را در سراسر ایران تجربه کنید.
              زیرساخت قدرتمند برای کسب‌وکارها و سازمان‌ها با پایداری و امنیت بالا
            </p>
            <div className="internet-hero-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('internet-features')}>
                مشاهده مزایا
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                ثبت نام اولیه ←
              </button>
            </div>
            <div className="internet-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۲۰+</span>
                <span className="stat-label">منطقه در تهران</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۳۰+</span>
                <span className="stat-label">شهر</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۹۹.۹٪</span>
                <span className="stat-label">آپتایم تضمینی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="internet-features" id="internet-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای اینترنت افراسل</span>
            <h3 className="sec-h">چرا اینترنت <em>پرسرعت</em> افراسل؟</h3>
            <p className="sec-p">تکنولوژی پیشرفته، پوشش گسترده و پشتیبانی حرفه‌ای در تمام نقاط ایران</p>
          </div>
          <div className="features-grid">
            {features.map((feature, i) => (
              <div key={i} className="feature-card">
                <span className="feature-icon">{feature.icon}</span>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="internet-benefits">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">کاربردها</span>
            <h3 className="sec-h">اینترنت پرسرعت برای <em>همه نیازها</em></h3>
            <p className="sec-p">از خانه و خانواده تا کسب‌وکارهای بزرگ و سازمان‌ها</p>
          </div>
          <div className="benefits-grid">
            {benefits.map((benefit, i) => (
              <div key={i} className="benefit-card">
                <div className="benefit-icon">✓</div>
                <div>
                  <h4 className="benefit-title">{benefit.title}</h4>
                  <p className="benefit-desc">{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology Tabs */}
      <section className="internet-tech">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">تکنولوژی</span>
            <h3 className="sec-h">اینترنت با <em>کیفیت بالا</em></h3>
            <p className="sec-p">انتخاب هوشمند بهترین تکنولوژی بر اساس نیاز شما در هر نقطه از ایران</p>
          </div>
          <div className="tech-tabs">
            <button 
              className={`tech-tab ${activeTab === 'p2p' ? 'active' : ''}`}
              onClick={() => setActiveTab('p2p')}
            >
              <span className="tech-icon">🔗</span>
              P2P اختصاصی
            </button>
            <button 
              className={`tech-tab ${activeTab === 'tdlte' ? 'active' : ''}`}
              onClick={() => setActiveTab('tdlte')}
            >
              <span className="tech-icon">📶</span>
              TD-LTE هوشمند
            </button>
          </div>
          <div className="tech-content">
            {activeTab === 'p2p' ? (
              <div className="tech-panel">
                <div className="tech-panel-icon">🔗</div>
                <h4>اینترنت P2P اختصاصی</h4>
                <p className="tech-desc">
                  اتصال نقطه‌به‌نقطه پرسرعت با پهنای باند اختصاصی و کیفیت تضمینی برای سازمان‌ها و کسب‌وکارهای بزرگ
                </p>
                <div className="tech-features">
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>مناطق تحت پوشش در تهران</strong>
                      <p>پوشش کامل در تمام مناطق ۴۰۰ گانه تهران با کیفیت تضمینی</p>
                    </div>
                  </div>
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>سرعت اختصاصی و تضمینی</strong>
                      <p>پهنای باند کاملاً اختصاصی بدون اشتراک با دیگر کاربران</p>
                    </div>
                  </div>
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>پایداری بالا با SLA رسمی</strong>
                      <p>آپتایم ۹۹.۹٪ تضمینی با قرارداد سطح خدمات (SLA) مکتوب</p>
                    </div>
                  </div>
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>مناسب برای سازمان‌ها و شرکت‌ها</strong>
                      <p>ارتباط امن و پایدار برای دیتاسنترها، مراکز داده و سازمان‌های بزرگ</p>
                    </div>
                  </div>
                </div>
                <div className="coverage-grid">
                  <h4>مناطق تحت پوشش P2P در تهران</h4>
                  <div className="coverage-tags">
                    {coverageAreas.map((area, i) => (
                      <span key={i} className="coverage-tag">{area}</span>
                    ))}
                  </div>
                  <p className="coverage-note">* پوشش کامل در تمام مناطق تهران با کیفیت تضمینی</p>
                </div>
              </div>
            ) : (
              <div className="tech-panel">
                <div className="tech-panel-icon">📶</div>
                <h4>اینترنت TD-LTE هوشمند</h4>
                <p className="tech-desc">
                  اینترنت بی‌سیم هوشمند با پوشش گسترده در سراسر کشور و انتخاب خودکار بهترین باند
                </p>
                <div className="tech-features">
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>پوشش در سراسر کشور</strong>
                      <p>دسترسی به اینترنت پرسرعت در تمام استان‌ها و شهرهای بزرگ ایران</p>
                    </div>
                  </div>
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>تکنولوژی هوشمند و خودکار</strong>
                      <p>انتخاب بهترین باند و کانال به صورت خودکار برای بهترین کیفیت</p>
                    </div>
                  </div>
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>نصب آسان و سریع</strong>
                      <p>راه‌اندازی در کمتر از ۲۴ ساعت بدون نیاز به کابل‌کشی پیچیده</p>
                    </div>
                  </div>
                  <div className="tech-feature-item">
                    <span>✓</span>
                    <div>
                      <strong>مقرون‌به‌صرفه و اقتصادی</strong>
                      <p>هزینه مناسب با کیفیت بالا برای استفاده خانگی و کسب‌وکارها</p>
                    </div>
                  </div>
                </div>
                <div className="coverage-grid">
                  <h4>شهرهای تحت پوشش TD-LTE</h4>
                  <div className="coverage-tags">
                    {cities.map((city, i) => (
                      <span key={i} className="coverage-tag city-tag">{city}</span>
                    ))}
                  </div>
                  <p className="coverage-note">* لیست شهرها در حال تکمیل است. برای استعلام دقیق با ما تماس بگیرید</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="internet-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h3 className="sec-h">پاسخ به <em>سوالات</em> شما</h3>
            <p className="sec-p">هر آنچه که باید درباره اینترنت پرسرعت افراسل بدانید</p>
          </div>
          <div className="faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="faq-item">
                <div className="faq-q">{faq.q}</div>
                <div className="faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="internet-cta">
        <div className="wrap">
          <div className="cta-box">
            <h3 className="cta-title">
              آماده‌اید تا <em>اینترنت پرسرعت</em> را تجربه کنید؟
            </h3>
            <p className="cta-desc">
              همین حالا ثبت نام اولیه را انجام دهید و از مزایای ویژه پیش‌خرید بهره‌مند شوید.
              تیم ما در اسرع وقت با شما تماس می‌گیرد.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>
                ثبت نام اولیه
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Internet;
